import { useAppDispatch } from "../../../hooks/hooks";
import { useCallback } from "react";
import { callAsync } from "../../../util/sliceUtil";
import { downloadTestResultAsync } from "../../../store/dataSearchSlice";
import { useDownloadFile } from "../../../hooks/common/useDownloadFile";
import { useUtil } from "../../../util/hooks/useUtil";
import { TestResultSearchCondition } from "../../../types/dataSearch";

interface ReturnType {
  downloadTestResults: (_: TestResultSearchCondition) => void;
}

export function useTestResultDownloader(): ReturnType {
  const dispatch = useAppDispatch();
  const { getDownloadExcelFile } = useDownloadFile();
  const { defaultErrorMessage } = useUtil();

  const downloadTestResults = useCallback(
    (condition: TestResultSearchCondition) => {
      callAsync(
        dispatch(downloadTestResultAsync(condition)).unwrap(),
        (result) => getDownloadExcelFile(result, "test-result"),
        () => {
          alert(defaultErrorMessage);
        }
      ).then();
    },
    [defaultErrorMessage, dispatch, getDownloadExcelFile]
  );

  return {
    downloadTestResults,
  };
}
